import { IColors } from "../models/Colors";
import { BentoTheme, WeVideoTheme } from "../models/WeVideoTheme";
import { ColorTokensProps, ElevationTokenProps } from "../tokens/colors/ColorTokens";

// TODO to be deprecated after full migration to bento
export const getWeVideoTheme = (colors: IColors): WeVideoTheme => ({
	colors: colors,
});

export const getBentoTheme = (
	colors: ColorTokensProps,
	elevation: ElevationTokenProps
): BentoTheme => ({
	colors: colors,
	elevation: elevation,
});
